import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ipConfig from "./ipConfig.json";
import Register from "./components/Register";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout"
import Thanks from "./components/Thanks"

export const config = {
  endpoint: `https://qtrip-frontend-nvr2.onrender.com/api/v1`,
};

function App() {
  return (
    <Router>
      <div className="App">
        {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
        <Switch>
          <Route path="/register" component={Register} />
          <Route path="/login" component={Login} />
          <Route exact path="/" component={Products} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/thanks" component={Thanks} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
